import { render, staticRenderFns } from "./NavigationMenuMobileListItem.vue?vue&type=template&id=512f56e4&scoped=true"
import script from "./NavigationMenuMobileListItem.vue?vue&type=script&lang=js"
export * from "./NavigationMenuMobileListItem.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuMobileListItem.vue?vue&type=style&index=0&id=512f56e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f56e4",
  null
  
)

export default component.exports